/**
 * Safe-area page padding for expert-review — matches hub (`HubInteractiveScreen`).
 *
 * Belongs here: shared top padding style for page chrome.
 * Does not belong here: top bar markup (see ExpertReviewTopBar).
 */
import type { CSSProperties } from 'react'
import { getTopPadding } from '../../../../utils/sessionStorage'

/** `paddingTop: calc(getTopPadding() + 10px)` — use on the page root, not on the top bar row. */
export function expertReviewSafeAreaTopStyle(): CSSProperties {
  return { paddingTop: `calc(${getTopPadding()}px + 10px)` }
}
